import request from './request';

// 登录接口
export function webAdminLogin(loginData) {
  return request({
    url: '/api/webadmin/login',
    method: 'post',
    data: loginData
  });
}

// 退出登录接口
export function webAdminLogout() {
  return request({
    url: '/api/webadmin/logout',
    method: 'post'
  });
}

// 获取账号列表
export function getAccountList() {
  return request({
    url: '/api/webadmin/accounts',
    method: 'get'
  });
}

// 创建账号
export function createAccount(accountData) {
  return request({
    url: '/api/webadmin/account',
    method: 'post',
    data: accountData
  });
}

// 更新账号
export function updateAccount(accountData) {
  return request({
    url: '/api/webadmin/account',
    method: 'put',
    data: accountData
  });
}

// 删除账号
export function deleteAccount(id) {
  return request({
    url: `/api/webadmin/account/${id}`,
    method: 'delete'
  });
}

// 更新账号状态
export function updateAccountStatus(id, status) {
  return request({
    url: `/api/webadmin/account/${id}/status/${status}`,
    method: 'put'
  });
}

// 删除移动端用户
export function deleteMobileUser(userId) {
  return request({
    url: `/api/user/web/users/${userId}`,
    method: 'delete'
  });
}